import {useCallback, useLayoutEffect, useState, type RefObject} from "react";

/** Measure unconstrained content, not the height of an already clipped scroll container. */
export function useOverlayPanelHeight(panelRef: RefObject<HTMLDivElement | null>, contentRef: RefObject<HTMLDivElement | null>) {
    const [height, setHeight] = useState(0);
    const measure = useCallback(() => {
        const panel = panelRef.current;
        const content = contentRef.current;
        if (!panel || !content) return;
        const style = getComputedStyle(panel);
        const edges = [style.paddingTop, style.paddingBottom, style.borderTopWidth, style.borderBottomWidth]
            .reduce((total, value) => total + (parseFloat(value) || 0), 0);
        const next = content.getBoundingClientRect().height + edges;
        setHeight(current => current === next ? current : next);
    }, [panelRef, contentRef]);
    // Includes width/content changes from React; measure before the initial panel is painted.
    useLayoutEffect(measure);
    useLayoutEffect(() => {
        if (typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver(measure);
        if (panelRef.current) observer.observe(panelRef.current);
        if (contentRef.current) observer.observe(contentRef.current);
        return () => observer.disconnect();
    });
    return height;
}
